/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Provide_ReasonInputs */

const en_provide_reason = /** @type {(inputs: Provide_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide a reason`)
};

const es_provide_reason = /** @type {(inputs: Provide_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporciona un motivo`)
};

/**
* | output |
* | --- |
* | "Please provide a reason" |
*
* @param {Provide_ReasonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const provide_reason = /** @type {((inputs?: Provide_ReasonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Provide_ReasonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_provide_reason(inputs)
	return es_provide_reason(inputs)
});